import React from 'react';

export default function New() {
  return <div><p>Clinical Review New - coming soon</p></div>;
}
